module.exports = function(text) {
  return text == 0 ? '0' : Number(text).toLocaleString();
};
